import {Directive, Inject, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import { AuthToken } from '@company-box/models';
import { AUTH_SVC, AuthService } from '@company-box/services';
import {NGXLogger} from 'ngx-logger';

@Directive({
    standalone: true,
    selector: '[appAccessRoleRequired]'
})
export class AccessRoleRequiredDirective {

    // tslint:disable-next-line:variable-name
    private _name: string = '';

    constructor(@Inject(AUTH_SVC) private authService: AuthService,
                private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private logger: NGXLogger) {
    }

    @Input() set name(name: string) {
        this._name = name;
    }

    get name() {
        return this._name;
    }

    @Input() set appAccessRoleRequired(roles: string[]) {

        if (this.authService.getToken()) {
            this.logger.debug('checking roles', roles);
            const token: AuthToken | undefined = this.authService.getToken();

            const passed = this.authService.validate(token, roles, this._name);

            if (passed) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            } else {
                this.viewContainer.clear();
            }
        }
    }
}
